module.exports = "pegasus_template/assets/blocks/column-3-theme5.png";